<!--  -->
<template>
  <div class="cen">
    <van-form @submit="pan">
      <van-field
        v-model="ruleForm1.idCard"
        input-align="right"
        name="学生身份证号"
        label="学生身份证号"
        placeholder="请输入身份证号"
        @blur="jiaoyan"
        @change="getAge"
        :rules="rules.idCard"
      />
      <van-field
        readonly
        input-align="right"
        clickable
        name="picker"
        :value="ruleForm1.entranceTeams"
        label="选择升学学段"
        placeholder="请选择学生升学学段"
        :rules="rules.entranceTeams"
      >
        <template #input>
          <van-radio-group
            v-model="ruleForm1.entranceTeams"
            direction="horizontal"
          >
            <van-radio name="0" :disabled="xdpan == 1">小学</van-radio>
            <van-radio name="1" :disabled="xdpan1 == 1">初中</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- <van-popup
        v-model="showPicker"
        position="bottom"
        v-if="entranceTeamsList.length > 0"
      >
        <van-picker
          show-toolbar
          :columns="entranceTeamsList"
          value-key="name"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup> -->
      <div class="dbbtn">
        <!-- <van-button
          :loading="codeDisabled"
          round
          block
          type="info"
          native-type="submit"
          >提交</van-button
        > -->
        <van-button class="btn" :loading="codeDisabled" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
    <notices></notices>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import "element-ui/lib/theme-chalk/index.css";
import rules from "@/utils/rules";
import { selectByIdCard, saveuser, getidno } from "@/api/news";
import sessionUtils from "@/utils/session-store-utils";
import notices from "../components/notices.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { notices },
  data() {
    //这里存放数据
    return {
      codeDisabled: false,
      timer: "",
      showPicker: false, //学段
      dialogForm: false,
      typeId: "",
      careId: "",
      ruleForm1: {
        idCard: "", //身份证号
        entranceTeams: "", //学段
        entranceTeamsid: "", //学段
      },
      disa1: true,
      disa7: true,
      age: "", //年龄
      loginUserId: "",
      chooseUser: [],
      lslist: [],
      entranceTeamsList: [
        { name: "小学", value: "0", disabled: false },
        { name: "初中", value: "1", disabled: false },
      ],
      specialList: [
        { name: "军警、消防子女", value: 1 },
        { name: "特殊人才子女", value: 2 },
        { name: "其他", value: 3 },
      ],
      rules: {
        idCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            required: true,
            message: "身份证号填写不合法",
            trigger: "blur",
            pattern:
              /^(([1-9][0-9]{5}(19|20)[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}([0-9]|X|x))|([1-9][0-9]{5}[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}))$/,
          },
        ],
        entranceTeams: [
          { required: true, message: "请选择入学学段", trigger: "change" },
        ],
      },
      tjpan: "0",
      xdpan: "",
      xdpan1: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.chooseUser = sessionUtils.getUser();
    this.loginUserId = this.chooseUser.id;
  },
  //方法集合
  methods: {
    onConfirm(s) {
      console.log(s);
      this.ruleForm1.entranceTeams = s.name;
      this.ruleForm1.entranceTeamsid = s.value;
      this.showPicker = false;
    },
    //用户须知公共弹窗
    tan() {
      this.$notice(true);
    },
    //查询该学生是否登记过的校验
    jiaoyan() {
      const reg =
        /^(([1-9][0-9]{5}(19|20)[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}([0-9]|X|x))|([1-9][0-9]{5}[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}))$/;
      if (reg.test(this.ruleForm1.idCard)) {
        this.selectByIdCard();
      }
    },
    //查询该学生是否重复填报
    async selectByIdCard() {
      this.xdpan = 0;
      this.xdpan1 = 0;
      const res = await selectByIdCard({
        idno: this.ruleForm1.idCard,
        id: this.chooseUser.id,
      });
      console.log(res);
      this.ruleForm1.entranceTeams = "";
      this.ruleForm1.entranceTeamsid = "";
      if (res.code == "200") {
        this.lslist = res.data;
        if (res.data.length > 0) {
          res.data.forEach((e) => {
            if (e.enrollmentGrade == "0") {
              this.xdpan = 1;
            } else if (e.enrollmentGrade == "1") {
              this.xdpan1 = 1;
            }
            if (this.chooseUser.phone != e.phone) {
              this.timer = setTimeout(() => {
                if (e.enrollmentGrade == "0") {
                  this.$dialog
                    .alert({
                      title: "温馨提示",
                      message:
                        "<div class='jianjuno'>该学生小学学段已被手机号<span  style='color: red;'>" +
                        e.phone +
                        "</span>登记!</div>",
                    })
                    .then(() => {
                      // on close
                    });
                } else {
                  this.$dialog
                    .alert({
                      title: "温馨提示",
                      message:
                        "<div class='jianjuno'>该学生初中学段已被手机号<span  style='color: red;'>" +
                        e.phone +
                        "</span>登记!</div>",
                    })
                    .then(() => {
                      // on close
                    });
                }
              }, 0);
            }
          });

          //   this.$forceUpdate();
          console.log(this.entranceTeamsList);
        }
      } else {
        this.$toast(res.msg);
      }
    },
    //查询该学生是否重复填报
    async cha() {
      const res = await getidno(this.ruleForm1);
      console.log(res);
      if (res.code == "200") {
        if (res.data.length == 0) {
          this.saveuser();
        } else {
          this.$toast("该学生已存在报名记录");
        }
      }
    },
    //校验
    sub(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.pan();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    pan() {
      const i = 3;
      //以2024年为准，小学20180831之前 初中20080901之后
      //以2024年为准
      //2024年小学入学年龄在20130831-20180831
      //初中入学年龄在20080901-20130901
      const year = new Date().getFullYear();
      console.log("今年" + year);
      const xxtime = year - 6 + "0831";
      const cztime = year - 16 + "0901";
      const xxtimeend = year - 6 - 5 + "0831";
      const cztimeend = year - 16 + 5 + "0901";
      // console.log(xxtime, cztime);
      if (this.lslist.length >= 2) {
        this.$toast("该学生已存在报名记录");
      } else {
        const s = Number(this.getBirthdayFromIdCard(this.ruleForm1.idCard));
        console.log(s);
        if (this.ruleForm1.entranceTeams == "0") {
          if (Number(20130831) <= s && s <= Number(20180831)) {
            if (this.tjpan == "0") {
              this.saveuser();
            }
          } else {
            this.$toast("该学生不符合入学年龄");
          }
        } else {
          if (Number(20130901) >= s && s >= Number(20080901)) {
            if (this.tjpan == "0") {
              this.saveuser();
            }
          } else {
            this.$toast("该学生不符合入学年龄");
          }
        }
      }
    },
    //保存
    async saveuser() {
      this.tjpan = 1;
      this.codeDisabled = true;
      const res = await saveuser({
        loginUserId: this.loginUserId,
        step: "1",
        idCard: this.ruleForm1.idCard,
        enrollmentGrade: this.ruleForm1.entranceTeams,
      });
      console.log(res);
      this.tjpan = 0;
      this.codeDisabled = false;
      if (res.code == "200") {
        sessionStorage.setItem("userInfoId", JSON.stringify(res.data.id));
        sessionStorage.setItem("idno", JSON.stringify(this.ruleForm1.idCard));
        sessionStorage.setItem(
          "xueduan",
          JSON.stringify(this.ruleForm1.entranceTeams)
        );
        sessionStorage.removeItem("from1");
        sessionStorage.removeItem("from2");
        sessionStorage.removeItem("from3");
        sessionStorage.removeItem("from4");
        sessionStorage.removeItem("oneid");
        sessionStorage.removeItem("twoid");
        sessionStorage.removeItem("threeid");
        sessionStorage.removeItem("fourid");
        sessionStorage.removeItem("fcimgstaus");
        sessionStorage.removeItem("imgstaus");
        this.$router.push({
          path: "/p-register",
          // query: { typeId: this.typeId, careId: this.careId },
        });
      } else {
        this.$toast(res.msg);
      }
    },

    permit() {
      this.$router.push("p-register");
    },

    async getInfo(idCard) {
      // this.entranceTeamsList = [];
      this.ruleForm1.entranceTeams = "";
      this.ruleForm1.entranceTeamsid = "";
      this.disa1 = false;
      this.disa7 = false;
      const params = Object.assign({});
      params.idCard = this.ruleForm1.idCard;
      const res = await findByIdCard(params);
      console.log(res);
      if (res.code == "200") {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].entranceGrade === "1") {
            this.disa1 = true;
          }
          if (res.data[i].entranceGrade === "7") {
            this.disa7 = true;
          }
        }
        this.entranceTeamsList = [
          { name: "一年级", value: "一年级", disabled: this.disa1 },
          { name: "七年级", value: "七年级", disabled: this.disa7 },
        ];
      }
    },

    //iden参数是身份证号
    getAge(iden) {
      console.log(iden);
      let val = iden.length;
      let myDate = new Date();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      let age = 0;

      if (val === 18) {
        age = myDate.getFullYear() - iden.substring(6, 10) - 1;
        if (
          iden.substring(10, 12) < month ||
          (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
        )
          age++;
      }
      // console.log("年龄为", age);
      this.age = age;
      //把算出的年龄给复制给from表单
      // this.$set(this.viewForm, "age", age);
    },
    getBirthdayFromIdCard(idCard) {
      let birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 15) {
          birthday = "19" + idCard.substr(6, 6);
        } else if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }
      }
      return birthday;
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/*@import url(); 引入公共css类*/
.cen {
  width: 100%;
}
/deep/.van-field__label {
  width: 4rem;
}
/deep/.van-radio__icon--checked .van-icon {
  color: #0f9386;
  background-color: #fff;
  border-color: #0f9386;
  width: 0.8rem;
  height: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding-bottom: 0.04rem;
}
/deep/.van-icon-success:before {
  content: "●" !important;
  width: 0.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
}
/deep/.van-radio__icon {
  width: 0.8rem;
  height: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn {
  width: 90%;
  background: #0f9386;
  color: #fff;
  border-radius: 0.2rem;
  font-size: 0.64rem;
  letter-spacing: 0.08rem;
}
.dbbtn {
  position: fixed;
  bottom: 1rem;
  width: 100%;
}
/deep/.van-field__error-message {
  text-align: right;
}
</style>